module.exports = __webpack_public_path__ + "b63f0a5e.webp";